// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var IvfTreatmentCycle;
(function (IvfTreatmentCycle) {
    IvfTreatmentCycle["first"] = "1";
    IvfTreatmentCycle["second"] = "2";
    IvfTreatmentCycle["third"] = "3";
    IvfTreatmentCycle["other"] = "O";
})(IvfTreatmentCycle || (IvfTreatmentCycle = {}));
//# sourceMappingURL=ivfTreatmentCycle.js.map